(function () {
  var rtl = document.documentElement.dir === 'rtl';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function raf(fn) { var q = false; return function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; fn(); }); }; }

  function initRail(rail) {
    if (rail.__n1) return; rail.__n1 = true;
    var track = rail.querySelector('[data-n1-track]');
    if (!track) return;
    var prev = rail.querySelector('[data-n1-nav="-1"]');
    var next = rail.querySelector('[data-n1-nav="1"]');
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var pos = Math.abs(track.scrollLeft);
      if (prev) prev.disabled = pos < 4;
      if (next) next.disabled = pos > max - 4;
    }
    rail.addEventListener('click', function (e) {
      var b = e.target.closest('[data-n1-nav]');
      if (!b || !rail.contains(b)) return;
      var dir = +b.getAttribute('data-n1-nav');
      track.scrollBy({ left: dir * (rtl ? -1 : 1) * track.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' });
    });
    track.addEventListener('scroll', raf(update), { passive: true });
    window.addEventListener('resize', raf(update));
    update();
  }

  function initSlider(root) {
    if (root.__n1) return; root.__n1 = true;
    var track = root.querySelector('[data-n1-slides]');
    if (!track) return;
    var slides = [].slice.call(track.children);
    var dots = root.querySelector('[data-n1-dots]');
    if (slides.length < 2) { root.classList.add('is-single'); return; }
    var idx = 0, timer = null, visible = true, paused = false;
    var delay = reduce ? 0 : (+root.getAttribute('data-autoplay') || 0) * 1000;
    if (dots) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', (i + 1) + ' / ' + slides.length);
        b.addEventListener('click', function () { go(i); restart(); });
        dots.appendChild(b);
      });
    }
    function go(i) {
      idx = (i + slides.length) % slides.length;
      var tr = track.getBoundingClientRect(), r = slides[idx].getBoundingClientRect();
      track.scrollBy({ left: (r.left + r.width / 2) - (tr.left + tr.width / 2), behavior: reduce ? 'auto' : 'smooth' });
    }
    function current() {
      var tr = track.getBoundingClientRect(), c = tr.left + tr.width / 2, best = 0, d = 1e9;
      slides.forEach(function (s, i) { var r = s.getBoundingClientRect(), dd = Math.abs(r.left + r.width / 2 - c); if (dd < d) { d = dd; best = i; } });
      return best;
    }
    function paint() {
      idx = current();
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      if (dots) [].forEach.call(dots.children, function (b, i) { b.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    }
    function restart() {
      clearInterval(timer);
      if (delay && visible && !paused && !document.hidden) timer = setInterval(function () { go(idx + 1); }, delay);
    }
    track.addEventListener('scroll', raf(paint), { passive: true });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-n1-go]');
      if (!b) return;
      go(idx + (+b.getAttribute('data-n1-go')) * 1);
      restart();
    });
    root.addEventListener('mouseenter', function () { paused = true; restart(); });
    root.addEventListener('mouseleave', function () { paused = false; restart(); });
    root.addEventListener('focusin', function () { paused = true; restart(); });
    root.addEventListener('focusout', function () { paused = false; restart(); });
    track.addEventListener('touchstart', function () { paused = true; restart(); }, { passive: true });
    track.addEventListener('touchend', function () { paused = false; restart(); }, { passive: true });
    document.addEventListener('visibilitychange', restart);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; restart(); }).observe(root);
    }
    paint();
    restart();
  }

  var clocks = [];
  var ticking = false;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(ms) {
    var s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    return (d ? d + (rtl ? ' يوم ' : 'd ') : '') + pad(h) + ':' + pad(m) + ':' + pad(x);
  }
  function tick() {
    var now = Date.now();
    clocks.forEach(function (el) {
      var end = el.__end;
      if (!end || end <= now) { el.hidden = true; return; }
      el.hidden = false;
      var c = el.querySelector('[data-n1-clock]');
      if (c) c.textContent = fmt(end - now);
    });
  }
  function initTimers(scope) {
    [].forEach.call(scope.querySelectorAll('[data-n1-end]'), function (el) {
      if (el.__n1) return; el.__n1 = true;
      el.__end = Date.parse(el.getAttribute('data-n1-end'));
      clocks.push(el);
    });
    tick();
    if (!ticking && clocks.length) { ticking = true; setInterval(tick, 1000); }
  }

  function init(scope) {
    scope = scope || document;
    [].forEach.call(scope.querySelectorAll('[data-n1-rail]'), initRail);
    [].forEach.call(scope.querySelectorAll('[data-n1-slider]'), initSlider);
    initTimers(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
